var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditEnabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979AAF",
    d: "M16.378 14.839c.344 0 .622.272.622.608 0 .336-.278.609-.622.609H.622c-.344 0-.622-.273-.622-.609 0-.336.278-.608.622-.608h15.756zm-.007-11.035l-9.87 9.656-3.848.385.393-3.764 8.583-8.397 1.288-1.26c.579-.566 1.588-.566 2.167 0l1.287 1.26c.288.28.45.663.45 1.06 0 .4-.16.777-.45 1.06zM4.046 12.482l1.888-.188 7.83-7.66-1.695-1.659-7.83 7.66-.193 1.847zM14 1.202c-.076 0-.15.03-.204.083l-.848.83 1.696 1.658.847-.83c.113-.11.113-.288 0-.398l-1.287-1.26c-.054-.053-.127-.083-.204-.082z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditEnabled);
export default __webpack_public_path__ + "static/media/icon-edit-enabled.58aa7cf196e25b761ef329cc92959479.svg";
export { ForwardRef as ReactComponent };